module.exports = __webpack_public_path__ + "affab7b0e7f023049ad94fb828abdab0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-yellow.png
// module id = 2016
// module chunks = 0